import Header from "../components/site/Header";
import Footer from "../components/site/Footer";
import PageHero from "../components/site/PageHero";
import { PageSection, InfoCards, CTABand, DisclaimerBox } from "../components/site/ContentBlocks";
import { serviceLd } from "../components/site/SEO";
import { TRADING_DISCLAIMER } from "../data/content";

const SUPPLIER_SERVICES = [
    {
        title: "Supplier Search",
        copy: "Our Vietnam agents identify suitable supplier connections based on your product, specification, quantity and destination requirements.",
    },
    {
        title: "Company and Document Checks",
        copy: "We coordinate initial company and document reviews before introductions progress, and can involve independent verification providers where required.",
    },
    {
        title: "Factory or Supplier Visits",
        copy: "Where appropriate, we help coordinate factory or supplier visits so buyers can review facilities and meet counterparties directly.",
    },
    {
        title: "Inspection Coordination",
        copy: "We coordinate with relevant independent inspection and quality service providers where required. Buyers should always complete their own independent due diligence.",
    },
    {
        title: "Samples and Quotations",
        copy: "Where available, we coordinate product information, samples, quotations and supporting documents between the parties.",
    },
    {
        title: "Ongoing Communication",
        copy: "Our team supports clear communication between buyer and supplier across languages and time zones through the agreed process.",
    },
];

export default function FindSuppliers() {
    return (
        <div className="grain bg-navy-deep" data-testid="find-suppliers-page">
            <Header />
            <main>
                <PageHero
                    seo={{
                        title: "Find Suppliers in Vietnam | Supplier Verification & Factory Sourcing — Viet Medica Ltd",
                        description:
                            "Find suppliers in Vietnam with local agent support — supplier searches, company and document checks, factory visit coordination and independent inspection coordination.",
                        path: "/find-suppliers-in-vietnam",
                        jsonLd: serviceLd(
                            "Find and Verify Suppliers in Vietnam",
                            "Supplier search, company checks, visit coordination and inspection coordination for international buyers sourcing from Vietnam.",
                            "/find-suppliers-in-vietnam"
                        ),
                    }}
                    crumbs={[{ label: "International Trading", href: "/international-trading" }, { label: "Vietnam Sourcing", href: "/vietnam-sourcing-agent" }, { label: "Find Suppliers" }]}
                    eyebrow="Trading and Sourcing from Vietnam"
                    title="Find Suppliers"
                    titleEm="in Vietnam."
                    copy="Identifying the right supplier is the foundation of every successful sourcing relationship. Our Vietnam agents help international buyers search, communicate and verify — with independent professional providers involved wherever formal verification is required."
                />

                <PageSection eyebrow="Supplier Support" title="How Our Agents Help You Verify and Connect" testid="supplier-services">
                    <InfoCards cards={SUPPLIER_SERVICES} cols={3} />
                </PageSection>

                <section className="bg-navy-surface py-20 lg:py-28">
                    <div className="mx-auto max-w-[1440px] space-y-10 px-5 lg:px-10">
                        <DisclaimerBox
                            text="Viet Medica Ltd provides introductions and sourcing coordination. We do not perform regulated inspections, customs clearance or legal verification ourselves; where these are required, we can coordinate with relevant independent professional service providers."
                            testid="find-suppliers-disclaimer"
                        />
                        <DisclaimerBox text={TRADING_DISCLAIMER} testid="find-suppliers-trading-disclaimer" />
                        <CTABand
                            title="Start your supplier search."
                            primary={{ label: "Send Product Requirement", to: "/vietnam-sourcing-enquiry", testid: "find-suppliers-cta" }}
                            secondary={{ label: "Sourcing Process", to: "/vietnam-sourcing-agent", testid: "find-suppliers-process-cta" }}
                        />
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
